import BigNumber from 'bignumber.js'
//import { format } from 'date-fns'
import { format } from 'date-fns-tz'

import useIsMobile from '../../hooks/useIsMobile'
import { MAX_TICK } from '../PoolsPage/helper'

export const formatDollarValue = (n: BigNumber.Value, toFixed = 2) => {
    const num = BigNumber(n)
    return num.gt(10 ** 9)
        ? num.div(10 ** 9).toFixed(toFixed) + 'b'
        : num.gt(10 ** 6)
        ? num.div(10 ** 6).toFixed(toFixed) + 'm'
        : num.gt(10 ** 3)
        ? num.div(10 ** 3).toFixed(toFixed) + 'k'
        : num.toFixed(2)
}

export const formatTimestamp = (timestamp_sec: number): string => {
    if (typeof timestamp_sec !== 'number') return ''
    const timestamp = Number(timestamp_sec) * 1000
    try {
        return `${format(timestamp, 'LLL', { timeZone: 'UTC' })} ${format(timestamp, 'd', { timeZone: 'UTC' })}`
    } catch (err) {
        console.error(`invalid time ${timestamp_sec}`)
    }
    return ''
}

export const formatTimestampDay = (timestamp_sec: number): string => {
    const timestamp = Number(timestamp_sec) * 1000
    try {
        return `${format(timestamp, 'd')}`
    } catch (err) {
        console.error(`invalid time ${timestamp_sec}`)
    }
    return ''
}

export const useChartHeight = () => {
    const isMobile = useIsMobile()

    return isMobile ? 192 : 354
}

export const getArrayRange = (dataArray: { tick: number; liq: number }[], minTick: number, maxTick: number) => {
    const startIndex = dataArray.findIndex((item) => item.tick - MAX_TICK >= minTick)
    const endIndex = dataArray.findIndex((item) => item.tick - MAX_TICK > maxTick)

    if (startIndex === -1 || endIndex === -1) {
        return []
    }

    let resultArray = dataArray.slice(startIndex, endIndex)
    const maxLength = 400

    if (resultArray.length > maxLength) {
        const step = Math.ceil(resultArray.length / maxLength)
        resultArray = resultArray.filter((_, index) => index % step === 0)
    }

    return resultArray
}

function padTicksArrayAroundCurrentTick(dataArray: { tick: number; liq: number }[], currentTickIndex: number, tickSpacing: number, currentTick: number) {
    const paddedArray: { tick: number; liq: number }[] = []
    const existingLength = dataArray.length
    const lowTick = dataArray[0].tick
    const paddingSizeLeft = Math.max(0, 200 - currentTickIndex)
    const paddingSizeRight = Math.max(0, 400 - paddingSizeLeft - existingLength)

    // Pad elements before currentTickIndex
    for (let i = 1; i <= paddingSizeLeft; i++) {
        const tick = lowTick - i * tickSpacing
        paddedArray.unshift({ tick: tick, liq: 0 })
    }

    // Copy existing array elements
    paddedArray.push(...dataArray)

    // Pad elements after currentTickIndex
    // for (let i = existingLength; i < existingLength + paddingSizeRight; i++) {
    for (let i = 1; i <= paddingSizeRight; i++) {
        const newTick = paddedArray[paddedArray.length - 1].tick + tickSpacing
        paddedArray.push({ tick: newTick, liq: 0 })
    }

    return paddedArray
}

export const getRangeArrayAroundTick = (dataArray: { tick: number; liq: number }[], targetTick: number, length: number) => {
    if (dataArray.length === 0) return { closestTickIndex: 0, data: dataArray }
    const closestTickIndex = dataArray.findIndex((item) => BigNumber(item.tick).minus(BigNumber(MAX_TICK)).eq(BigNumber(targetTick)))
    const distanceBetweenTicks = dataArray[1].tick - dataArray[0].tick

    let rangeArray = dataArray.slice(closestTickIndex - length > 0 ? closestTickIndex - length : 0, closestTickIndex + length)
    let closestTickIndex2 = rangeArray.findIndex((item) => BigNumber(item.tick).minus(BigNumber(MAX_TICK)).eq(BigNumber(targetTick)))

    if (rangeArray.length < 400) {
        rangeArray = padTicksArrayAroundCurrentTick(rangeArray, closestTickIndex2, distanceBetweenTicks, rangeArray[closestTickIndex2].tick)
        closestTickIndex2 = 200
    }
    return { closestTickIndex: closestTickIndex2, data: rangeArray }
}

export function findClosestTickIndex(ticks: { tick: number }[], targetTick: number): number | null {
    let closestIndex = 0
    let closestDifference = Math.abs(ticks[0].tick - MAX_TICK - targetTick)

    for (let i = 1; i < ticks.length; i++) {
        const currentDifference = Math.abs(ticks[i].tick - MAX_TICK - targetTick)

        if (currentDifference < closestDifference) {
            closestIndex = i
            closestDifference = currentDifference
        }
    }

    return closestIndex
}
